import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  selectHomeSlideId,
  selectemployeeData,
} from "../../store/home/home.selectors";
import QRCode from "react-qr-code";
import { Link } from "react-router-dom";
import "animate.css";
import ShareModal from "../../components/modal/share-modal";
import VideoModal from "../../components/modal/video-modal";
import ImageModal from "../../components/modal/image-modal";
import CommentModal from "../../components/modal/comment-modal";
import { NotificationManager } from "react-notifications";
import UserService from "../../services/user/user.service";
import AppConfig from "../../config/app.config";
import { Backdrop, CircularProgress } from "@mui/material";
import {
  updateBannerFavorite,
  updateBannerShare,
  updateBannerComment,
} from "../../store/home/home.actions";
import { format } from "date-fns";
import { ReactComponent as Play } from "../../assets/images/PLAY.svg";
import ReactPlayer from "react-player";
import YoutubePlayer from "react-player/youtube";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Modal } from "react-bootstrap";

const mapStateToProps = (state) => {
  return {
    employeeData: selectemployeeData(state),
    homeSlideId: selectHomeSlideId(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      updateBannerFavorite,
      updateBannerShare,
      updateBannerComment,
    },
    dispatch
  ),
});

class Banner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
      isWebWidth: window.innerWidth > 991,
      isAnimate: false,
      isDetailsDivOverflowing: false,
      isShareModalVisible: false,
      isVideoModalVisible: false,
      videoSource: null,
      isImageModalVisible: false,
      imageSource: null,
      isImageLoaded: false,
      isCommentModalVisible: false,
      isArModalVisible: false,
      commentsList: [],
      isArVisible: false,
    };
    this.animationTimer = null;
    this.detailsDiv = null;
  }

  componentDidMount() {
    window.addEventListener("resize", this.resizeListener);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.homeSlideId !== this.props.homeSlideId &&
      this.props.homeSlideId === this.props.bannerData?.projectId &&
      this.props.bannerData?.url != null &&
      this.props.bannerData?.url !== ""
    ) {
      this.setState({ isAnimate: true });
      this.animationTimer = setTimeout(() => {
        this.setState({ isAnimate: false });
        this.animationTimer = null;
      }, 3500);
    }
    if (
      this.props.bannerData?.images[0]?.fileUrl !==
      prevProps.bannerData?.images[0]?.fileUrl
    ) {
      this.setState({
        isImageLoaded: false,
      });
    }
  }

  componentWillUnmount() {
    if (this.animationTimer != null) {
      this.setState({ isAnimate: false });
      clearTimeout(this.animationTimer);
      this.animationTimer = null;
    }
    this.detailsDiv = null;
    window.removeEventListener("resize", this.resizeListener);
  }

  resizeListener = () => {
    const isWebWidth = window.innerWidth > 991;
    const isOverFlowing =
      this.detailsDiv != null ? this.isOverflown(this.detailsDiv) : false;
    var newState = {
      isDetailsDivOverflowing: isOverFlowing,
    };
    if (this.state.isWebWidth !== isWebWidth) {
      newState = {
        ...newState,
        isWebWidth,
      };
    }
    if (Object.keys(newState).length > 0) {
      this.setState(newState);
    }
  };

  isOverflown = ({ clientHeight, scrollHeight }) => {
    return scrollHeight > clientHeight;
  };

  updateFavoriteStatus = async () => {
    if (
      this.props.employeeData?.employeeId != null &&
      this.props.bannerData != null
    ) {
      try {
        this.setState({ isLoading: 1 });
        const res = await UserService.updateFavoriteStatus({
          subscriptionId: AppConfig.API.SUBSCRIPTION_ID,
          verticalId: AppConfig.API.VERTICAL_ID,
          appId: AppConfig.API.APP_ID,
          projectId: this.props.bannerData.projectId,
          favorite: this.props.bannerData.isFavorite === 1 ? 0 : 1,
          employeeId: this.props.employeeData?.employeeId,
        });
        if (res.error != null) {
          if (res.error?.response?.data?.message != null) {
            NotificationManager.error(
              "",
              res.error.response.data.message,
              3000
            );
          } else {
            NotificationManager.error(
              "",
              this.props.bannerData.isFavorite === 1
                ? "Could not remove from Favorites."
                : "Could not add to Favorites.",
              3000
            );
          }
        } else {
          if (res["status"]) {
            NotificationManager.success(
              "",
              this.props.bannerData.isFavorite === 1
                ? "Removed from Favorites."
                : "Added to Favorites.",
              3000
            );
            const isFavorite = this.props.bannerData.isFavorite === 1 ? 0 : 1;
            this.props.updateBannerFavorite({
              ...this.props.bannerData,
              isFavorite: isFavorite,
              totalFavoriteCount:
                this.props.bannerData.isFavorite === 1
                  ? this.props.bannerData.totalFavoriteCount - 1
                  : this.props.bannerData.totalFavoriteCount + 1,
            });
          } else {
            NotificationManager.error(
              "",
              this.props.bannerData.isFavorite === 1
                ? "Could not remove from Favorites."
                : "Could not add to Favorites.",
              3000
            );
          }
        }
      } catch (err) {
        NotificationManager.error(
          "",
          this.props.bannerData.isFavorite === 1
            ? "Could not remove from Favorites."
            : "Could not add to Favorites.",
          3000
        );
      }
      this.setState({ isLoading: 0 });
    }
  };

  saveShareProjectLog = async () => {
    if (
      this.props.employeeData?.employeeId != null &&
      this.props.bannerData != null
    ) {
      try {
        // this.setState({ isLoading: 1 });
        const res = await UserService.saveShareDataLog({
          loginEmployeeId: this.props.employeeData?.employeeId,
          subscriptionId: AppConfig.API.SUBSCRIPTION_ID,
          verticalId: AppConfig.API.VERTICAL_ID,
          appId: AppConfig.API.APP_ID,
          projectId: this.props.bannerData.projectId,
        });
        if (res["status"]) {
          this.props.updateBannerShare({
            projectId: this.props.bannerData.projectId,
          });
        }
      } catch (err) {}
      // this.setState({ isLoading: 0 });
    }
  };

  share = async (url, title) => {
    try {
      var canShare;
      if (
        navigator.share === undefined ||
        !(
          navigator.userAgent.toLowerCase().includes("android") ||
          navigator.userAgent.toLowerCase().includes("ios")
        )
      ) {
        canShare = false;
      }
      if (!title) {
        canShare = false;
      }
      var shareData = { text: title, title };
      if (url) {
        shareData.url = url;
      }
      if (
        canShare !== false &&
        navigator.canShare &&
        navigator.canShare(shareData)
      ) {
        canShare = true;
      } else {
        canShare = false;
      }
      if (canShare) {
        if (navigator.canShare && navigator.canShare(shareData)) {
          await navigator.share(shareData);
          await this.saveShareProjectLog();
        }
      } else {
        this.setState({ isShareModalVisible: true });
      }
    } catch (err) {}
  };

  openCommentModel = async () => {
    this.setState({
      isCommentModalVisible: true,
      commentsList: this.props.bannerData.comments,
    });
  };

  updateComment = async (commentList) => {
    this.props.updateBannerComment({
      ...this.props.bannerData,
      comments: commentList,
    });
  };

  render() {
    const { images, videos, documents } = this.props.bannerData;
    return this.props.bannerData != null ? (
      <div className="banner banner-guitar">
        {this.state.isLoading === 1 && (
          <Backdrop style={{ zIndex: 9999999, color: "#fa96c8" }} open>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        <div className="banner-guitar-section">
          <Swiper
            autoHeight={true}
            spaceBetween={0}
            modules={[Navigation]}
            navigation={images != null && images.length > 1}
            className="imageSwiper"
          >
            {images != null
              ? (images.length > 0
                  ? [
                      ...images.filter((x) => x.isPrimaryImage === 1),
                      ...images.filter((x) => x.isPrimaryImage === 0),
                    ]
                  : [{ projectPictureId: 0, fileUrl: null }]
                ).map((image, index) => {
                  return (
                    <SwiperSlide>
                      <div className="banner-guitarimg">
                        <LazyLoadImage
                          key={image?.fileUrl}
                          src={
                            image?.fileUrl != null
                              ? image?.fileUrl
                              : require("../../assets/images/NoImage.png")
                          }
                          className="guitar-img"
                          alt="guitar-img"
                          onLoadStart={(e) =>
                            this.setState({ isImageLoaded: false })
                          }
                          onLoad={(e) => this.setState({ isImageLoaded: true })}
                        />
                        {!this.state.isImageLoaded && (
                          <CircularProgress
                            style={{ position: "absolute" }}
                            color="error"
                          />
                        )}
                        {this.props.bannerData.url != null &&
                        this.props.bannerData.url !== "" ? (
                          <>
                            <div className="ARicon" id="aricon-web">
                              <div className="dropdown" id="dropdown-basic">
                                <button
                                  className={`btn dropdown-toggle ${
                                    this.state.isAnimate
                                      ? "animate__animated animate__heartBeat animate__repeat-3"
                                      : ""
                                  }`}
                                  type="button"
                                  id="dropdownMenuButton"
                                  data-mdb-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <img
                                    src={require("../../assets/images/AR icon.png")}
                                    className="ARicon-img"
                                    alt="ARicon"
                                    id="ARicon-img-web"
                                  />
                                  <img
                                    src={require("../../assets/images/AR-white.png")}
                                    className="ARicon-img"
                                    alt="ARicon"
                                    id="ARicon-img-mobile"
                                    onClick={() =>
                                      this.setState({
                                        isArModalVisible: true,
                                      })
                                    }
                                  />
                                </button>
                                <div
                                  className="dropdown-menu"
                                  aria-labelledby="dropdownMenuButton"
                                >
                                  <div className="ar-rqcode">
                                    <img
                                      src={require("../../assets/images/AR icon (1).png")}
                                      className="ARicon-newimg"
                                      alt="ARicon"
                                      id="web-ar-white"
                                    />
                                    <img
                                      src={require("../../assets/images/AR-white.png")}
                                      className="ARicon-newimg"
                                      alt="ARicon"
                                      id="mobile-ar-white"
                                    />
                                    <div className="ar-icondetails">
                                      {/* <div className="ar-icon-close">
                                        <img
                                          src={require("../../assets/images/close-comment.png")}
                                          className="close-cooment"
                                          alt="close-cooment"
                                          id="ar-blackclose"
                                        />
                                        <img
                                          src={require("../../assets/images/close-white.png")}
                                          className="close-cooment"
                                          alt="close-cooment"
                                          id="ar-whiteclose"
                                        />
                                      </div> */}
                                      {this.props.bannerData.arDescription !=
                                        null &&
                                      this.props.bannerData.arDescription !==
                                        "" ? (
                                        <>
                                          <p
                                            className="view"
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                this.props.bannerData
                                                  .arDescription,
                                            }}
                                          />
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      <Link
                                        to={{
                                          pathname: this.props.bannerData.url,
                                        }}
                                        target="_blank"
                                        className="ar-trylink"
                                      >
                                        <button
                                          type="button"
                                          className="ar-trybtn"
                                        >
                                          Try It
                                        </button>
                                      </Link>
                                      <h5>Scan for an AR experience</h5>
                                      <QRCode
                                        size={256}
                                        className="QR-img"
                                        value={this.props.bannerData.url}
                                        viewBox={`0 0 256 256`}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : null}
                        <div className="socialmedia-icon">
                          <div className="icons">
                            <img
                              src={
                                this.props.bannerData.isFavorite === 1
                                  ? require("../../assets/images/Favorite-saved.png")
                                  : require("../../assets/images/Favorite.png")
                              }
                              className="Favorite-img"
                              alt="Favorite"
                              onClick={() => {
                                if (
                                  this.props.employeeData?.employeeId != null
                                ) {
                                  this.updateFavoriteStatus();
                                } else {
                                  this.props.showSigninRegisterModal();
                                }
                              }}
                            />
                            <p>{this.props.bannerData.totalFavoriteCount}</p>
                          </div>
                          <div className="icons">
                            <img
                              src={require("../../assets/images/Comment.png")}
                              className="Comment-img"
                              alt="Comment"
                              onClick={() => {
                                if (
                                  this.props.employeeData?.employeeId != null
                                ) {
                                  this.openCommentModel();
                                } else {
                                  this.props.showSigninRegisterModal();
                                }
                              }}
                            />
                            <p>
                              {this.props.bannerData.comments != null &&
                              this.props.bannerData.comments.length > 0
                                ? this.props.bannerData.comments.length
                                : 0}
                            </p>
                          </div>
                          <div className="icons">
                            <img
                              src={require("../../assets/images/Share.png")}
                              className="Share-img"
                              alt="Share"
                              onClick={() => {
                                this.share(
                                  `https://electrified.rocks/${this.props.bannerData.projectId}`,
                                  this.props.bannerData.objectName ?? ""
                                );
                              }}
                            />
                            <p>{this.props.bannerData.totalShareCount}</p>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })
              : null}
          </Swiper>
          <div
            className={`guitar-description ${
              this.state.isExpanded ? "expand-descriptionpanel" : ""
            } ${
              this.state.isExpanded ||
              (this.state.isWebWidth && this.state.isDetailsDivOverflowing)
                ? "swiper-no-swiping"
                : ""
            }`}
          >
            <img
              src={require("../../assets/images/slider-bar.png")}
              className="sidebarimg-mobile"
              alt="sidebar-img"
              onClick={() =>
                this.setState({ isExpanded: !this.state.isExpanded }, () => {
                  const isOverFlowing =
                    this.detailsDiv != null
                      ? this.isOverflown(this.detailsDiv)
                      : false;
                  if (this.state.isDetailsDivOverflowing !== isOverFlowing) {
                    this.setState({
                      isDetailsDivOverflowing: isOverFlowing,
                    });
                  }
                })
              }
            />
            <div
              ref={(ref) => {
                this.detailsDiv = ref;
              }}
              className="banner-details"
            >
              <h4>{this.props.bannerData.objectName}</h4>
              <p>
                {this.props.bannerData.artistName != null &&
                this.props.bannerData.artistName !== "" ? (
                  <>
                    {this.props.bannerData.artistName}
                    <br />
                  </>
                ) : null}
                {this.props.bannerData.dueDate != null &&
                this.props.bannerData.dueDate !== "" ? (
                  <>
                    {format(
                      new Date(this.props.bannerData.dueDate),
                      "LLL. d, yyyy"
                    )}
                    <br />
                  </>
                ) : this.props.bannerData.year != null &&
                  this.props.bannerData.year !== "" ? (
                  <>
                    {this.props.bannerData.year}
                    <br />
                  </>
                ) : null}
                {[
                  this.props.bannerData.address1,
                  this.props.bannerData.city,
                  this.props.bannerData.state,
                  this.props.bannerData.country,
                ].filter((x) => x !== "" && x != null).length > 0 ? (
                  <>
                    {[
                      this.props.bannerData.address1,
                      this.props.bannerData.city,
                      this.props.bannerData.state,
                      this.props.bannerData.country,
                    ]
                      .filter((x) => x !== "" && x != null)
                      .join(", ")}{" "}
                    <br />
                  </>
                ) : null}
                {this.props.bannerData.material != null &&
                this.props.bannerData.material !== "" ? (
                  <>
                    {this.props.bannerData.material}
                    <br />
                  </>
                ) : null}
                {this.props.bannerData.lenderName != null &&
                this.props.bannerData.lenderName !== "" ? (
                  <>
                    <span>{this.props.bannerData.lenderName}</span>
                    <br />
                  </>
                ) : null}
                {this.props.bannerData.labelCopy != null &&
                this.props.bannerData.labelCopy !== "" ? (
                  <>
                    <br />
                    <br />
                    {this.props.bannerData.labelCopy}
                    <br />
                  </>
                ) : null}
                {[
                  this.props.bannerData.roomName,
                  this.props.bannerData.floorName,
                ].filter((x) => x !== "" && x != null).length > 0 && (
                  <>
                    <br />
                    <b style={{ fontFamily: "avenir-heavy" }}>
                      Exhibit Location:
                    </b>{" "}
                    {[
                      this.props.bannerData.roomName,
                      this.props.bannerData.floorName,
                    ]
                      .filter((x) => x !== "" && x != null)
                      .join(", ")}
                  </>
                )}
              </p>
              {(images != null &&
                images.filter((x) => x.isPrimaryImage === 0).length > 0) ||
              (videos != null && videos.length > 0) ||
              (documents != null && documents.length > 0) ? (
                <div className="guitar-content">
                  {images
                    .filter((x) => x.isPrimaryImage === 0)
                    .map((image, index) => (
                      <div key={index} className="guitar-contentimg">
                        <img
                          src={image?.fileUrl}
                          onClick={() =>
                            this.setState({
                              isImageModalVisible: true,
                              imageSource: image?.fileUrl,
                            })
                          }
                          alt="guitar-img"
                        />
                        {image.fileName != null && image.fileName !== "" ? (
                          <h5>{image.fileName}</h5>
                        ) : null}
                      </div>
                    ))}
                  {videos.map((video, index) => (
                    <div
                      key={index}
                      className="guitar-contentvideo"
                      onClick={() =>
                        this.setState({
                          isVideoModalVisible: true,
                          videoSource: video?.fileUrl,
                        })
                      }
                    >
                      {video?.fileUrl.includes("youtube.com") ||
                      video?.fileUrl.includes("youtu.be") ? (
                        <YoutubePlayer
                          url={video?.fileUrl}
                          // height={"100%"}
                          // width={"100%"}
                          className="video-playerdesign"
                        />
                      ) : (
                        <ReactPlayer
                          url={video?.fileUrl}
                          // height={"100%"}
                          // width={"100%"}
                          className="video-playerdesign"
                        />
                      )}
                      {video.fileName != null && video.fileName !== "" ? (
                        <h5>{video.fileName}</h5>
                      ) : null}
                      <div className="video-player-btn">
                        <Play className="videoplay-iconimg" />
                      </div>
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <Modal
          show={this.state.isArModalVisible}
          onHide={() => {
            this.setState({ isArModalVisible: false });
          }}
          backdropClassName="arModal"
          keyboard={false}
          id="armobile-modal"
        >
          <div id="aricon-modal">
            <div className="order-confirmation">
              {/* <Modal.Header closeButton></Modal.Header> */}
              <div className="ar-rqcode">
                <img
                  src={require("../../assets/images/AR-white.png")}
                  className="ARicon-newimg"
                  alt="ARicon"
                  id="mobile-ar-white"
                />
                <div className="ar-icondetails">
                  <div className="ar-icon-close">
                    <img
                      src={require("../../assets/images/close-white.png")}
                      className="close-cooment"
                      alt="close-cooment"
                      id="ar-whiteclose"
                      onClick={() => this.setState({ isArModalVisible: false })}
                    />
                  </div>
                  {this.props.bannerData.arDescription != null &&
                  this.props.bannerData.arDescription !== "" ? (
                    <>
                      <p
                        className="view"
                        dangerouslySetInnerHTML={{
                          __html: this.props.bannerData.arDescription,
                        }}
                      />
                    </>
                  ) : (
                    ""
                  )}
                  <Link
                    to={{
                      pathname: this.props.bannerData.url,
                    }}
                    target="_blank"
                    className="ar-trylink"
                  >
                    <button type="button" className="ar-trybtn">
                      Try It
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <ShareModal
          employeeId={this.props.employeeData?.employeeId}
          projectId={this.props.bannerData?.projectId}
          url={`https://electrified.rocks/${this.props.bannerData.projectId}`}
          title={this.props.bannerData.objectName}
          show={this.state.isShareModalVisible}
          hideModal={() => this.setState({ isShareModalVisible: false })}
        />
        {this.state.isVideoModalVisible && (
          <VideoModal
            show={this.state.isVideoModalVisible}
            hideModal={() =>
              this.setState({ isVideoModalVisible: false, videoSource: null })
            }
            isImage={this.state.isImage}
            source={this.state.videoSource}
          />
        )}
        {this.state.isImageModalVisible && (
          <ImageModal
            show={this.state.isImageModalVisible}
            hideModal={() =>
              this.setState({ isImageModalVisible: false, imageSource: null })
            }
            source={this.state.imageSource}
          />
        )}
        {this.state.isCommentModalVisible && (
          <CommentModal
            show={this.state.isCommentModalVisible}
            commentsList={this.state.commentsList}
            employeeId={this.props.employeeData?.employeeId}
            employeeName={this.props.employeeData?.name}
            projectId={this.props.bannerData.projectId}
            updateComment={this.updateComment}
            hideModal={() =>
              this.setState({ isCommentModalVisible: false, commentsList: [] })
            }
          />
        )}
      </div>
    ) : null;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Banner);
